import Nouislider from "nouislider-react";
import React, { useEffect, useState } from "react";
import "nouislider/distribute/nouislider.css";
import { NumericFormat } from "react-number-format";

function PercentContainer({
  onChange,
  defaultValue,
  readOnly,
  validationRules,
  type,
}) {
  // const [currentValue, setCurrentValue] = useState(0);
  const [currentValue, setCurrentValue] = useState(
    defaultValue ? +defaultValue.toString().replace(",", ".").toLowerCase() : 0
  );
  const [prevValue, setPrevValue] = useState(0);
  const [error, setError] = useState("");
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(100);
  const [step, setStep] = useState(1);
  const [isSliding, setIsSlinding] = useState(false);
  const [inputValue, setInputValue] = useState(
    (defaultValue || "").toString().replace(".", ",")
  );

  useEffect(
    (type) => {
      const validationRulesMin = validationRules?.find((x) => x.type === "min");
      const validationRulesMax = validationRules?.find((x) => x.type === "max");
      const validationRulesStep = validationRules?.find(
        (x) => x.type === "step"
      );
      if (validationRulesMin?.value && validationRulesMin?.value !== "-") {
        setMin(formatValue(validationRulesMin.value));
      } else if (type === "percentslider") {
        setMin(0);
      }
      if (validationRulesMax?.value && validationRulesMax?.value !== "-") {
        setMax(formatValue(validationRulesMax.value));
      } else if (type === "percentslider") {
        setMax(100);
      }
      if (validationRulesStep?.value && validationRulesStep?.value !== "-") {
        setStep(formatValue(validationRulesStep.value));
      } else if (type === "percentslider") {
        setStep(0.1);
      }
    },
    [validationRules]
  );

  function roundToStep(value, step, min = 0) {
    const base = min || 0;
    return (Math.round((value - base) / step) * step + base).toString();
  }

  useEffect(() => {
    setInputValue(formatValue(defaultValue));
    setCurrentValue(formatValue(defaultValue));
    setPrevValue(formatValue(defaultValue));
  }, [defaultValue]);

  function toFrenchFormatValueString(value) {
    return value.toString().replace(".", ",");
  }

  function formatValue(value) {
    value = (parseFloat(value.toString().replace(",", ".")) * 100).toFixed(4);
    value = parseFloat(value);
    return value;
  }

  function handleEndSlider(value) {
    let tmpValue = parseFloat(value.toString().replace(",", ".").toLowerCase());

    if (type === "percentslider") {
      tmpValue = roundToStep(
        parseFloat(value.toString().replace(",", ".").toLowerCase()),
        step,
        min
      );
    }

    if (checkAllowed(tmpValue)) {
      setPrevValue(tmpValue);
      setCurrentValue(tmpValue.toString().replace(",", ".").toLowerCase());
      setInputValue(tmpValue.toString().replace(".", ","));
      onChange(+tmpValue.toString().replace(",", ".").toLowerCase());
      setError("");
    } else {
      // if (validationRules?.find(x => x.type === "min") && tmpValue <= min)
      if (min !== undefined && max === undefined && tmpValue < min) {
        setError(
          `La valeur saisie doit être supérieure ou égale à ${toFrenchFormatValueString(
            min
          )}%`
        );
      }
      // else if (validationRules?.find(x => x.type === "max") && tmpValue >= max)
      else if (min === undefined && max !== undefined && tmpValue > max) {
        setError(
          `La valeur saisie doit être inférieure ou égale à ${toFrenchFormatValueString(
            max
          )}%`
        );
      } else
        setError(
          `La valeur saisie doit être comprise entre ${toFrenchFormatValueString(
            min
          )}% et ${toFrenchFormatValueString(max)}%`
        );
      setInputValue(+prevValue.toString().replace(".", ","));
      setCurrentValue(+prevValue.toString().replace(",", ".").toLowerCase());
      onChange(+prevValue.toString().replace(",", ".").toLowerCase());
    }
  }

  function checkAllowed(tmpValue) {
    return (
      (min === undefined && max === undefined) ||
      (min !== undefined && max === undefined && tmpValue >= parseFloat(min)) ||
      (min === undefined && max !== undefined && tmpValue <= parseFloat(max)) ||
      (min !== undefined &&
        max !== undefined &&
        tmpValue >= parseFloat(min) &&
        tmpValue <= parseFloat(max))
    );
  }

  function handleCursorPosition(e) {
    if (e.key === ".") {
      e.target.setSelectionRange(
        e.target.value.length - 2,
        e.target.value.length - 2
      );
    }
  }

  return (
    <div className="slider-container">
      {type === "percentslider" && min !== undefined && max !== undefined && (
        <>
          <div
            className="d-flex justify-content-between"
            style={{ paddingBottom: "6px" }}
          >
            <span>{min}</span>
            <span>{max}</span>
          </div>
          <Nouislider
            range={{
              ...((min || min === 0) && {
                min: +parseFloat(min),
              }),
              ...((max || max === 0) && {
                max: +parseFloat(max),
              }),
            }}
            start={prevValue}
            onStart={() => setIsSlinding(true)}
            onEnd={(e) => {
              setIsSlinding(false);
              handleEndSlider(parseFloat(e).toFixed(2));
            }}
            onChange={(e) => {
              handleEndSlider(parseFloat(e).toFixed(2));
            }}
            onSlide={(e) => setCurrentValue(parseFloat(e).toFixed(2))}
            disabled={readOnly}
            connect
            step={+parseFloat(step)}
          />
        </>
      )}
      <NumericFormat
        type="text"
        decimalSeparator=","
        valueIsNumericString={true}
        value={isSliding ? currentValue : inputValue}
        onValueChange={(values) =>
          setInputValue(values.value.replace(".", ","))
        }
        suffix={" %"}
        onBlur={(e) => {
          handleEndSlider(e.target.value);
          setCurrentValue(e.target.value);
        }}
        onKeyDown={(e) =>
          e.key === "Enter" ? handleEndSlider(e.target.value) : ""
        }
        className="form-control"
        disabled={readOnly}
        onKeyUp={(e) => handleCursorPosition(e)}
      />
      {error && <p className="text-danger m-0">{error}</p>}
    </div>
  );
}

export default PercentContainer;
